import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaVolumeMute, FaVolumeUp, FaTrash } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';
import '../../styles/Header.css';

const TYPE_STYLE = {
  new:  { bg: '#f0fdf4', border: '#86efac', text: '#15803d', dot: '#22c55e' },
  warn: { bg: '#fffbeb', border: '#fde68a', text: '#92400e', dot: '#f59e0b' },
};

function timeAgo(ts) {
  const m = Math.floor((Date.now() - ts) / 60000);
  if (m < 1)  return 'İndicə';
  if (m < 60) return `${m} dəq əvvəl`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} saat əvvəl`;
  return `${Math.floor(h / 24)} gün əvvəl`;
}

const Header = () => {
  const { business } = useAuth();
  const { pendingCount, soundEnabled, toggleSound, notifLog, unreadCount, markAllRead, clearLog } = useNotifications();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  // Close panel on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const handleBellClick = () => {
    if (!open) markAllRead();
    setOpen(p => !p);
  };

  const totalBadge = unreadCount + pendingCount;

  return (
    <div className="header">
      <h1>Business Panel</h1>
      <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>

        {/* Sound toggle */}
        <button
          onClick={toggleSound}
          title={soundEnabled ? 'Səsi söndür' : 'Səsi aç'}
          style={{
            background: soundEnabled ? '#f0fdf4' : '#f5f5f5',
            border: `1px solid ${soundEnabled ? '#86efac' : '#e0e0e0'}`,
            borderRadius: 10, padding: '7px 10px',
            cursor: 'pointer', color: soundEnabled ? '#16a34a' : '#aaa',
            fontSize: 14, display: 'flex', alignItems: 'center',
            transition: 'all 0.2s',
          }}
        >
          {soundEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
        </button>

        {/* Notification bell + dropdown */}
        <div ref={panelRef} style={{ position: 'relative' }}>
          <button
            onClick={handleBellClick}
            title="Bildirişlər"
            style={{
              position: 'relative',
              background: totalBadge > 0 ? '#fff7ed' : '#f5f5f5',
              border: `1px solid ${totalBadge > 0 ? '#fed7aa' : '#e0e0e0'}`,
              borderRadius: 10, padding: '7px 10px',
              cursor: 'pointer',
              color: totalBadge > 0 ? '#ea580c' : '#aaa',
              fontSize: 15, display: 'flex', alignItems: 'center',
              transition: 'all 0.2s',
              animation: pendingCount > 0 ? 'bellShake 2s ease infinite' : 'none',
            }}
          >
            <FaBell />
            {totalBadge > 0 && (
              <span style={{
                position: 'absolute', top: -6, right: -6,
                background: '#ef4444', color: '#fff',
                fontSize: 10, fontWeight: 800,
                borderRadius: '50%', minWidth: 18, height: 18,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '0 3px',
                boxShadow: '0 2px 6px rgba(239,68,68,0.4)',
                border: '2px solid #fff',
              }}>
                {totalBadge > 9 ? '9+' : totalBadge}
              </span>
            )}
          </button>

          {/* Dropdown panel */}
          {open && (
            <div className="notif-panel">
              <div className="notif-panel-header">
                <span className="notif-panel-title">Bildirişlər</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {pendingCount > 0 && (
                    <button
                      className="notif-go-bookings"
                      onClick={() => { setOpen(false); navigate('/bookings'); }}
                    >
                      {pendingCount} gözləyir →
                    </button>
                  )}
                  {notifLog.length > 0 && (
                    <button className="notif-clear-btn" onClick={clearLog} title="Hamısını sil">
                      <FaTrash />
                    </button>
                  )}
                </div>
              </div>

              <div className="notif-panel-list">
                {notifLog.length === 0 ? (
                  <div className="notif-empty">
                    <FaBell style={{ fontSize: 28, opacity: 0.2 }} />
                    <p>Hələ bildiriş yoxdur</p>
                  </div>
                ) : (
                  notifLog.map(n => {
                    const s = TYPE_STYLE[n.type] || TYPE_STYLE.new;
                    return (
                      <div
                        key={n.id}
                        className={`notif-item${n.read ? '' : ' notif-unread'}`}
                        style={{ borderLeft: `3px solid ${s.dot}` }}
                      >
                        <div className="notif-item-top">
                          <span className="notif-item-title" style={{ color: s.text }}>{n.title}</span>
                          <span className="notif-item-time">{timeAgo(n.ts)}</span>
                        </div>
                        {n.body && <div className="notif-item-body">{n.body}</div>}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>

        <span style={{ fontSize: 13, color: '#888' }}>{business?.email}</span>
      </div>

      <style>{`
        @keyframes bellShake {
          0%,100% { transform: rotate(0deg); }
          10%,30%  { transform: rotate(-12deg); }
          20%,40%  { transform: rotate(12deg); }
          50%      { transform: rotate(0deg); }
        }
      `}</style>
    </div>
  );
};

export default Header;
